import React, { useState, useRef, useEffect } from "react";
import "../../styles/App.css";

function ProfilePage({
  user,
  setUser,
  company,
  onClose,
  apiKeys = [],
  currentApiKey = "",
  onCompanyChange,
}) {
  const [tab, setTab] = useState("about");
  const [draft, setDraft] = useState(() => ({ ...user }));
  const [companyInfo, setCompanyInfo] = useState(() =>
    company && company.data ? company.data.info : null
  );
  const fileInput = useRef(null);

  useEffect(() => {
    setCompanyInfo(company && company.data ? company.data.info : null);
  }, [company]);

  const triggerFile = () => fileInput.current && fileInput.current.click();

  const onFileChange = (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      setDraft((d) => ({ ...d, avatar: dataUrl }));
    };
    reader.readAsDataURL(f);
  };

  const onSave = () => {
    if (typeof setUser === "function") {
      setUser(draft);
      try {
        localStorage.setItem("user", JSON.stringify(draft));
        if (draft && draft.avatar) {
          localStorage.setItem("avatar_dataurl", draft.avatar);
        }
      } catch (e) {}
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-left">
        <div className="profile-card">
          <div className="profile-avatar-large">
            {draft?.avatar ? (
              <img src={draft.avatar} alt={draft.name || "Avatar"} />
            ) : (
              <div className="profile-initials">
                {draft && draft.name
                  ? draft.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .toUpperCase()
                  : "U"}
              </div>
            )}
          </div>

          <div style={{ marginTop: 12, textAlign: "center" }}>
            <div className="profile-name">{draft?.name || "Unnamed"}</div>
            <div className="profile-role">
              {company?.data?.info?.owner_name || draft?.role || "User"}
            </div>
          </div>

          <div
            style={{
              marginTop: 14,
              display: "flex",
              gap: 8,
              justifyContent: "center",
            }}
          >
            <input
              ref={fileInput}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onFileChange}
            />
            <button className="btn btn-outline" onClick={triggerFile}>
              Change Photo
            </button>
            {draft?.avatar && draft.avatar !== (user?.avatar || "") && (
              <button className="btn" onClick={onSave}>
                Update Photo
              </button>
            )}
          </div>

          <div className="profile-follow" style={{ marginTop: 16 }}>
            <p style={{ margin: 0, fontSize: 13, color: "#6b7280" }}>
              Follow on
            </p>
            <div
              style={{
                display: "flex",
                gap: 8,
                marginTop: 8,
                justifyContent: "center",
              }}
            >
              <button className="icon-btn">f</button>
              <button className="icon-btn">t</button>
              <button className="icon-btn">in</button>
            </div>
          </div>
        </div>

        <div className="profile-card" style={{ marginTop: 18 }}>
          <h4 className="card-title">Personal Details</h4>
          <div className="profile-row">
            <span>Phone</span>
            <span>{draft?.phone || draft?.mobile || "-"}</span>
          </div>
          <div className="profile-row">
            <span>Mail</span>
            <span>{draft?.email || "-"}</span>
          </div>
          <div style={{ marginTop: 12 }}>
            <label
              style={{
                display: "block",
                fontSize: 13,
                color: "#6b7280",
                marginBottom: 8,
              }}
            >
              Active Company
            </label>
            <select
              value={currentApiKey}
              onChange={(e) =>
                onCompanyChange && onCompanyChange(e.target.value)
              }
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: 8,
                border: "1px solid var(--wv-divider)",
              }}
            >
              <option value="">Select company</option>
              {apiKeys.map((item, idx) => {
                const comp = item.company || item;
                const keyVal =
                  item.api_key || comp.api_key || comp.id || String(comp.id);
                const name = comp?.name || keyVal;
                return (
                  <option key={idx} value={keyVal}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>

      <div className="profile-right">
        <div className="profile-tabs">
          <button
            className={`tab ${tab === "about" ? "active" : ""}`}
            onClick={() => setTab("about")}
          >
            About
          </button>
          <button
            className={`tab ${tab === "company" ? "active" : ""}`}
            onClick={() => setTab("company")}
          >
            Company
          </button>
          <button
            className={`tab ${tab === "settings" ? "active" : ""}`}
            onClick={() => setTab("settings")}
          >
            Settings
          </button>
        </div>

        <div className="profile-content">
          {tab === "about" && (
            <div>
              <h3>About</h3>
              <p style={{ color: "#4b5563" }}>
                {draft?.bio ||
                  "No bio available. You can add personal information in Settings."}
              </p>

              <div style={{ marginTop: 18 }}>
                <h4>Full Name</h4>
                <div className="muted">{draft?.name || "-"}</div>

                <h4 style={{ marginTop: 12 }}>Mobile</h4>
                <div className="muted">
                  {draft?.phone || draft?.mobile || "-"}
                </div>

                <h4 style={{ marginTop: 12 }}>Email</h4>
                <div className="muted">{draft?.email || "-"}</div>
              </div>
            </div>
          )}

          {tab === "company" && (
            <div>
              <h3>Company</h3>
              {!companyInfo && (
                <div className="muted">No company selected.</div>
              )}
              {companyInfo && (
                <div style={{ marginTop: 12 }}>
                  <div className="profile-row">
                    <span>Name</span>
                    <span>{companyInfo.name || "-"}</span>
                  </div>
                  <div className="profile-row">
                    <span>Owner</span>
                    <span>{companyInfo.owner_name || "-"}</span>
                  </div>
                  <div className="profile-row">
                    <span>Owner Email</span>
                    <span>{companyInfo.owner_email || "-"}</span>
                  </div>
                  <div className="profile-row">
                    <span>Plan</span>
                    <span>{companyInfo.plan || "-"}</span>
                  </div>
                  <div className="profile-row">
                    <span>Status</span>
                    <span>{companyInfo.subscription_status || "-"}</span>
                  </div>
                  <div className="profile-row">
                    <span>Cycle End</span>
                    <span>{companyInfo.current_cycle_end || "-"}</span>
                  </div>
                  {companyInfo.description && (
                    <div style={{ marginTop: 10 }}>
                      <h4>Description</h4>
                      <div className="muted">{companyInfo.description}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {tab === "settings" && (
            <div>
              <h3>Settings</h3>
              <div style={{ marginTop: 12 }}>
                <label className="form-row">
                  <span>Name</span>
                  <input value={draft?.name || ""} disabled />
                </label>

                <label className="form-row">
                  <span>Email</span>
                  <input value={draft?.email || ""} disabled />
                </label>

                <label className="form-row">
                  <span>Phone</span>
                  <input value={draft?.phone || ""} disabled />
                </label>

                <label className="form-row">
                  <span>Bio</span>
                  <textarea
                    value={draft?.bio || ""}
                    onChange={(e) =>
                      setDraft((d) => ({ ...d, bio: e.target.value }))
                    }
                  />
                </label>

                <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                  <button className="btn" onClick={onSave}>
                    Save
                  </button>
                  <button
                    className="btn btn-outline"
                    onClick={() => {
                      setDraft({ ...user });
                    }}
                  >
                    Reset
                  </button>
                  <button className="btn" onClick={onClose}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
